import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class IdentityModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][IdentityModel] organizationId is mandatory`);
        }
        return `/ticket/organizations/${organizationId}/mailing/identity`;
    }
}
